// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3JoKp","right":"styles_right__1xigT"};